import { render, staticRenderFns } from "./JobListContent.vue?vue&type=template&id=0ad50e80&scoped=true&"
import script from "./JobListContent.vue?vue&type=script&lang=js&"
export * from "./JobListContent.vue?vue&type=script&lang=js&"
import style0 from "./JobListContent.vue?vue&type=style&index=0&id=0ad50e80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad50e80",
  null
  
)

export default component.exports